import React from "react";
import Page from "../templates/support/environment/spotlight/coastal-protection-and-mangrove-projects";
import { Helmet } from "react-helmet";

export default function home() {
  return (
    <div>
      <Helmet>
        <title>
          Coastal and Mangrove protection | Environmental CSR projects |
          Hirdaramani
        </title>
        <meta
          name="title"
          content="Coastal and Mangrove protection | Environmental CSR projects | Hirdaramani"
        />
        <meta
          name="description"
          content="Hirdaramani supports coastal protection & mangrove projects in Vietnam & Sri Lanka, reducing erosion & empowering communities"
        />
        <link
          rel="canonical"
          href="https://sustainability.hirdaramani.com/support/environment/spotlight-coastal-protection-and-mangrove-projects/"
        />
        <meta property="og:locale" content="en_US" />
        <meta name="keywords" content="Environmental CSR" />
        <meta
          property="og:title"
          content="Coastal and Mangrove protection | Environmental CSR projects | Hirdaramani"
        />
        <meta
          property="og:description"
          content="Hirdaramani supports coastal protection & mangrove projects in Vietnam & Sri Lanka, reducing erosion & empowering communities"
        />
        <meta
          property="og:image"
          content="https://hirdaramani-microsite.sgp1.digitaloceanspaces.com/images/logo.png"
        />
        <meta
          property="og:url"
          content="https://sustainability.hirdaramani.com/support/environment/spotlight-coastal-protection-and-mangrove-projects/"
        />
      </Helmet>

      <Page />
    </div>
  );
}
